// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cSKs","colBig":"styles_colBig__2ewFv","colSmall":"styles_colSmall__1b7x-"};